import { render } from "./FeaturesComponent.vue?vue&type=template&id=d51e1d30"
import script from "./FeaturesComponent.vue?vue&type=script&lang=js"
export * from "./FeaturesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__